export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewSharedAuthenticatorModal,
        ImportSharedAuthenticatorsModal,
        ManageSharedAuthenticatorModal,
        SharedAccountShare,
    ) {
        this.$state = $state;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.ManageSharedAuthenticatorModal = ManageSharedAuthenticatorModal;
        this.SharedAccountShare = SharedAccountShare;
    }

    reload() {
        return this.$state.reload(this.$state.current);
    }

    showAddModal() {
        this.publicServicesWithSsoAnd2FA$.get()
            .then(items => this.AddNewSharedAuthenticatorModal(items))
            .then(() => this.reload())
    }

    showImportModal() {
        return this.ImportSharedAuthenticatorsModal().then(() => this.reload());
    }

    showManageModal(account) {
        return this.ManageSharedAuthenticatorModal(account).then(() => this.reload());
    }

    showShareModal(account) {
        return this.SharedAccountShare(account);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/shared-authenticators.controller.js